import { AppSidebar } from '@/components/AppSidebar'
import { PresenceIndicator } from '@/components/primitives'
import { RecordSheetProvider } from '@/components/record-sheet/RecordSheetProvider'
import { DensityToggle } from '@/components/primitives/DensityToggle'
import { ThemeToggle } from '@/components/primitives/ThemeToggle'
import { Separator } from '@/components/ui/separator'
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger
} from '@/components/ui/sidebar'
import { TooltipProvider } from '@/components/ui/tooltip'
import { findActiveLeaf } from '@/lib/nav'
import { useMemo } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

export function AppLayout() {
  const location = useLocation()

  const { title, parentTitle } = useMemo(() => {
    const leaf = findActiveLeaf(location.pathname)
    if (leaf) return { title: leaf.title, parentTitle: leaf.parentTitle }
    return { title: 'XOBLACK Admin', parentTitle: undefined }
  }, [location.pathname])

  return (
    <TooltipProvider delayDuration={120}>
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset>
          <header className="flex h-14 shrink-0 items-center gap-2 border-b px-4">
            <SidebarTrigger className="-ml-1" />
            <Separator orientation="vertical" className="mx-1 h-4" />
            {parentTitle && (
              <>
                <span className="text-sm text-muted-foreground">
                  {parentTitle}
                </span>
                <span className="text-muted-foreground/50">/</span>
              </>
            )}
            <h1 className="text-sm font-medium">{title}</h1>
            <div className="ml-auto flex items-center gap-1">
              <DensityToggle />
              <ThemeToggle />
              <PresenceIndicator />
            </div>
          </header>
          <div className="flex-1 overflow-auto p-6">
            <RecordSheetProvider>
              <Outlet />
            </RecordSheetProvider>
          </div>
        </SidebarInset>
      </SidebarProvider>
    </TooltipProvider>
  )
}
